import Tab from '@mui/material/Tab';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { TAB_INDEX } from '../pages';
import { Box, Grid } from '@mui/material';
interface CarcinogenicReportTabProps {
    label: string;
    value: TAB_INDEX;
    onlyVisual: boolean;
    active?: boolean;
    complete?: boolean;
    disabled?: boolean;
}

const getDataStateIcon = (complete: boolean) => {
    if (complete) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                color="white"
                sx={{
                    backgroundColor: '#4CAF50',
                    borderRadius: '50%',
                    width: `${18}px`,
                    height: `${18}px`
                }}
            >
                <CheckIcon sx={{ fontSize: 15 }} />
            </Box>
        );
    } else {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                color="white"
                sx={{
                    backgroundColor: '#FFBD1B',
                    borderRadius: '50%',
                    width: `${18}px`,
                    height: `${18}px`
                }}
            >
                <PriorityHighIcon sx={{ fontSize: 15 }} />
            </Box>
        );
    }
};

const CarcinogenicReportTab = (props: CarcinogenicReportTabProps) => {
    const { label, value, active, complete, disabled = false, onlyVisual } = props;
    return (
        <Grid
            container
            alignItems={'center'}
            gap={1}
            pl={1}
            pr={1}
            borderRadius={' 6px 6px 0px  0px'}
            bgcolor={`${active ? '#FFFFFF' : '#F3F8F8'}`}
        >
            {!onlyVisual && getDataStateIcon(complete ?? false)}
            <Tab
                {...props}
                disabled={disabled}
                sx={{
                    fontSize: '18px',
                    fontFamily: 'Roboto, sans-serif',
                    flex: 1,
                    color: '#989898',
                    fontWeight: '400',
                    textAlign: 'left',
                    height: '74px'
                }}
                label={label}
                value={value}
            />
        </Grid>
    );
};

export { CarcinogenicReportTab };
